import {openDialog} from 'platform/components';

import {ServiceAccountKeyResultDialogContent} from './ServiceAccountKeyResultDialogContent';

const SERVICE_ACCOUNT_KEY_RESULT_DIALOG_ID = 'serviceAccountKeyResultDialog';

interface OpenServiceAccountKeyResultDialogArgs {
  title: string;
  keyId: string;
  privateKeyPem: string;
  // Called once the dialog has been fully dismissed. The create flow uses this to
  // navigate only after the private key has been acknowledged — navigating while the
  // dialog is open would close it, since the dialog manager clears dialogs on route change.
  onClose?: () => void;
}

export function openServiceAccountKeyResultDialog(args: OpenServiceAccountKeyResultDialogArgs) {
  openDialog(
    <ServiceAccountKeyResultDialogContent
      keyId={args.keyId}
      privateKeyPem={args.privateKeyPem}
      data-testid={SERVICE_ACCOUNT_KEY_RESULT_DIALOG_ID}
    />,
    {
      id: SERVICE_ACCOUNT_KEY_RESULT_DIALOG_ID,
      title: args.title,
      size: 'large',
      scrollBehavior: 'outside',
      withAdditionalFooter: false,
      onCloseComplete: args.onClose,
      'data-testid': SERVICE_ACCOUNT_KEY_RESULT_DIALOG_ID,
    }
  );
}
